import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import * as cartActions from './cart/actionCreators';

const actionsArray = Object.values(cartActions);

const gtmMiddleware = createListenerMiddleware();
gtmMiddleware.startListening({
  matcher: isAnyOf(...actionsArray),
  effect: (action /*, { getState, dispatch, getOriginalState } */) => {
    const gtmEvent = {
      ...action.payload,
      meta: {
        'action.type': action.type,
        createdAt: new Date().toISOString()
      }
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmEvent);
  }
});

export { gtmMiddleware };
